export default __webpack_public_path__ + "static/media/check-mark@2x.617b4b47.png";